export const zIndex = {
    AppBar: 800,
    SideBar: 800,
    viewHeader: 800,
    AssetListHeader: 700,
    FAB: 850,
    Wizard: 900,
}


// WEBPACK FOOTER //
// ./src/styles/styles.js